import React from 'react';

interface PreviousAdvanceCarePlanProps {
  advanceCarePlan: string;
  setAdvanceCarePlan: (value: string) => void;
  residentFullName: string;
}

interface RadioType {
  value: string;
  label: string;
}
const PreviousAdvanceCarePlan: React.FC<PreviousAdvanceCarePlanProps> = ({
  advanceCarePlan,
  setAdvanceCarePlan,
  residentFullName,
}) => {
  const advanceCarePlanOptions: RadioType[] = [
    { value: 'no', label: 'No' },
    { value: 'notSure', label: 'Not sure' },
    { value: 'notAvailable', label: 'Yes, but it is not currently available' },
    {
      value: 'createdIndependently',
      label:
        'Yes, it was created by the resident independently when they had mental capacity',
    },
    {
      value: 'createdWithProfessional',
      label:
        'Yes, it was created by the resident with a health/social care professional when they had mental capacity',
    },
    {
      value: 'createdWithLovedOne',
      label:
        'Yes, it was created by the resident with a loved one when they had mental capacity',
    },
    {
      value: 'otherPleaseDescribe',
      label: 'Other, please describe',
    },
  ];

  const handleChangeCareStatusOption = (e: any) => {
    const selectedStatus = e.target.value;
    setAdvanceCarePlan(selectedStatus);
  };

  return (
    <div className="care-status mt-10 govuk-bp:mt-14">
      <h1 className="govuk-heading-xl second-title">
        Previously Created Advance Care Plans
      </h1>
      <div className="govuk-body">
        Does {residentFullName} have one or more previously created Advance Care
        Plans? *This does not include medicalised documents such as LPAs,
        DNACPRs, ReSPECT, ACMPs, TEPs etc)
      </div>
      <div className="govuk-form-group mt-10 govuk-bp:mt-14">
        <fieldset className="govuk-fieldset">
          <legend className="govuk-fieldset__legend govuk-fieldset__legend--l">
            <h1 className="govuk-fieldset__heading">
              Has {residentFullName} completed one or more Advance Care Plans
              prior to this care plan?
            </h1>
          </legend>
          <div id="acp-options-hint" className="govuk-hint">
            Is there a previously created Advance Care Plan available for{' '}
            {residentFullName}
          </div>
          <div
            className="govuk-radios care-status__radios"
            data-module="govuk-radios"
          >
            {advanceCarePlanOptions.map(option => {
              return (
                <div className="govuk-radios__item" key={option.value}>
                  <input
                    className="govuk-radios__input"
                    id={option.value}
                    name={option.value}
                    type="radio"
                    value={option.value}
                    checked={advanceCarePlan === option.value}
                    onChange={handleChangeCareStatusOption}
                  />
                  <label
                    className="govuk-label govuk-radios__label"
                    htmlFor={option.value}
                  >
                    {option.label}
                  </label>
                </div>
              );
            })}
          </div>
        </fieldset>
      </div>
    </div>
  );
};

export default PreviousAdvanceCarePlan;
